"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * convert the given Scheme into a Rule that allows undefined value
 * @param scheme the scheme
 */
function optional(scheme) {
    return (value, context) => {
        if (value !== undefined) {
            validate(value, scheme, context);
        }
        return '';
    };
}
exports.optional = optional;
/**
 * convert the given Scheme into a Rule that allows null value
 * @param scheme the scheme
 */
function nullable(scheme) {
    return (value, context) => {
        if (value !== null) {
            validate(value, scheme, context);
        }
        return '';
    };
}
exports.nullable = nullable;
/** Validator class */
class Validator {
    constructor(scheme) {
        this.scheme = scheme;
    }
    test(value, context) {
        return validate(value, this.scheme, context);
    }
}
exports.Validator = Validator;
/** Error class describes validation error */
class ValidationError extends Error {
    constructor(rawMessage, context) {
        super(context ? `${context}: ${rawMessage}` : rawMessage);
        this.rawMessage = rawMessage;
        this.context = context;
    }
}
exports.ValidationError = ValidationError;
ValidationError.prototype.name = 'ValidationError';
/**
 * direct function to validate value without construct Validator object
 * @param value value to be validated
 * @param scheme scheme
 * @param context context string appears in error object
 */
function validate(value, scheme, context) {
    if (Array.isArray(scheme)) {
        if (!Array.isArray(value)) {
            throw new ValidationError('expected array', context || '');
        }
        value.forEach((el, i) => validate(el, scheme[0], context ? `${context}.#${i}` : `#${i}`));
    }
    else if (scheme instanceof Function) {
        const errMsg = scheme(value, context);
        if (errMsg) {
            throw new ValidationError(errMsg, context || '');
        }
    }
    else {
        if (!(value instanceof Object)) {
            throw new ValidationError('expected object', context || '');
        }
        for (const key in scheme) {
            if (scheme.hasOwnProperty(key)) {
                validate(value[key], scheme[key], context ? `${context}.${key}` : key);
            }
        }
    }
    return value;
}
exports.validate = validate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFVQTs7O0dBR0c7QUFDSCxTQUFnQixRQUFRLENBQUksTUFBaUI7SUFDekMsT0FBTyxDQUFDLEtBQVEsRUFBRSxPQUFnQixFQUFFLEVBQUU7UUFDbEMsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1lBQ3JCLFFBQVEsQ0FBSSxLQUFLLEVBQUUsTUFBTSxFQUFFLE9BQU8sQ0FBQyxDQUFBO1NBQ3RDO1FBQ0QsT0FBTyxFQUFFLENBQUE7SUFDYixDQUFDLENBQUE7QUFDTCxDQUFDO0FBUEQsNEJBT0M7QUFFRDs7O0dBR0c7QUFDSCxTQUFnQixRQUFRLENBQUksTUFBaUI7SUFDekMsT0FBTyxDQUFDLEtBQVEsRUFBRSxPQUFnQixFQUFFLEVBQUU7UUFDbEMsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1lBQ2hCLFFBQVEsQ0FBSSxLQUFLLEVBQUUsTUFBTSxFQUFFLE9BQU8sQ0FBQyxDQUFBO1NBQ3RDO1FBQ0QsT0FBTyxFQUFFLENBQUE7SUFDYixDQUFDLENBQUE7QUFDTCxDQUFDO0FBUEQsNEJBT0M7QUFFRCxzQkFBc0I7QUFDdEIsTUFBYSxTQUFTO0lBQ2xCLFlBQXFCLE1BQWlCO1FBQWpCLFdBQU0sR0FBTixNQUFNLENBQVc7SUFBSSxDQUFDO0lBRXBDLElBQUksQ0FBQyxLQUFRLEVBQUUsT0FBZ0I7UUFDbEMsT0FBTyxRQUFRLENBQUksS0FBSyxFQUFFLElBQUksQ0FBQyxNQUFNLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDbkQsQ0FBQztDQUNKO0FBTkQsOEJBTUM7QUFFRCw2Q0FBNkM7QUFDN0MsTUFBYSxlQUFnQixTQUFRLEtBQUs7SUFDdEMsWUFBcUIsVUFBa0IsRUFBVyxPQUFlO1FBQzdELEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEdBQUcsT0FBTyxLQUFLLFVBQVUsRUFBRSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQTtRQUR4QyxlQUFVLEdBQVYsVUFBVSxDQUFRO1FBQVcsWUFBTyxHQUFQLE9BQU8sQ0FBUTtJQUVqRSxDQUFDO0NBQ0o7QUFKRCwwQ0FJQztBQUVELGVBQWUsQ0FBQyxTQUFTLENBQUMsSUFBSSxHQUFHLGlCQUFpQixDQUFBO0FBRWxEOzs7OztHQUtHO0FBQ0gsU0FBZ0IsUUFBUSxDQUFJLEtBQVEsRUFBRSxNQUFpQixFQUFFLE9BQWdCO0lBQ3JFLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsRUFBRTtRQUN2QixJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN2QixNQUFNLElBQUksZUFBZSxDQUFDLGdCQUFnQixFQUFFLE9BQU8sSUFBSSxFQUFFLENBQUMsQ0FBQTtTQUM3RDtRQUNELEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FDcEIsUUFBUSxDQUFDLEVBQUUsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxHQUFHLE9BQU8sS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7S0FDdkU7U0FBTSxJQUFJLE1BQU0sWUFBWSxRQUFRLEVBQUU7UUFDbkMsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQTtRQUNyQyxJQUFJLE1BQU0sRUFBRTtZQUNSLE1BQU0sSUFBSSxlQUFlLENBQUMsTUFBTSxFQUFFLE9BQU8sSUFBSSxFQUFFLENBQUMsQ0FBQTtTQUNuRDtLQUNKO1NBQU07UUFDSCxJQUFJLENBQUMsQ0FBQyxLQUFLLFlBQVksTUFBTSxDQUFDLEVBQUU7WUFDNUIsTUFBTSxJQUFJLGVBQWUsQ0FBQyxpQkFBaUIsRUFBRSxPQUFPLElBQUksRUFBRSxDQUFDLENBQUE7U0FDOUQ7UUFDRCxLQUFLLE1BQU0sR0FBRyxJQUFJLE1BQU0sRUFBRTtZQUN0QixJQUFJLE1BQU0sQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLEVBQUU7Z0JBQzVCLFFBQVEsQ0FBQyxLQUFLLENBQUMsR0FBWSxDQUFDLEVBQUUsTUFBTSxDQUFDLEdBQUcsQ0FBQyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLElBQUksR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFBO2FBQ2xGO1NBQ0o7S0FDSjtJQUNELE9BQU8sS0FBSyxDQUFBO0FBQ2hCLENBQUM7QUF2QkQsNEJBdUJDIn0=